export const formatCurrency = (value, symbol, view) => {
  if (value == null) return 'N/A';
  if (view !== "Sales") return value.toFixed(4);
  if (value == null) return 'N/A';
  const rounded = Math.round(value);
  const absValue = Math.abs(rounded);
  const formatted = absValue.toLocaleString();
  return value < 0 ? `-${symbol}${formatted}` : `${symbol}${formatted}`;
};
